import { __extends, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons';
import { Button } from '../Button/Button.component.js';
import { Icon } from '../Icon/Icon.component.js';
import { propTypes, defaultProps } from './Pagination.types.js';
import ButtonBase from '../ButtonBase/ButtonBase.component.js';
import styles from './Pagination.module.scss.js';

var Pagination = /** @class */ (function (_super) {
    __extends(Pagination, _super);
    function Pagination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Pagination.prototype.componentDidMount = function () {
        if (this.props.v2) {
            console.warn('DEPRECATION WARNING: The `v2` prop is deprecated and support for it will be removed soon.');
        }
        if (this.props.singlePage) {
            console.warn('DANGER: The `singlePage` prop has been removed, please use `pagesDisplayedLimit` instead.');
        }
    };
    Pagination.prototype.handleClick = function (page) {
        var _a = this.props, currentPage = _a.currentPage, numberOfPages = _a.numberOfPages, onPageChange = _a.onPageChange;
        if (typeof page === 'number') {
            onPageChange(page);
        }
        else {
            switch (page) {
                case 'prev':
                    onPageChange(currentPage - 1);
                    break;
                case 'next':
                    onPageChange(currentPage + 1);
                    break;
                case 'first':
                    onPageChange(1);
                    break;
                case 'last':
                    onPageChange(numberOfPages);
                    break;
            }
        }
    };
    Pagination.prototype.getRange = function (start, end) {
        var length = end - start + 1;
        var range = [];
        for (var i = 0; i < length; i++) {
            range.push(start + i);
        }
        return range;
    };
    Pagination.prototype.renderNumbers = function (currentPage, total, pagesDisplayedLimit) {
        var _this = this;
        var neighbors = Math.floor(pagesDisplayedLimit / 2);
        var adjustParLimit = pagesDisplayedLimit % 2 === 0 ? 1 : 0;
        var siblingsStart = Math.max(Math.min(currentPage - neighbors + adjustParLimit, total - pagesDisplayedLimit + 1), 1);
        var siblingsEnd = Math.min(Math.max(currentPage + neighbors, pagesDisplayedLimit), total);
        var range = this.getRange(siblingsStart, siblingsEnd);
        var pages = range.map(function (val) {
            return _this.renderItem(currentPage, val);
        });
        return pages;
    };
    Pagination.prototype.renderItem = function (currentPage, value) {
        var _this = this;
        return (React__default.createElement(Button, { variant: "tertiary", key: "page" + value, type: "button", disabled: String(value).includes('Ellipsis'), onClick: function () { return _this.handleClick(value); }, className: clsx(styles.Pagination_item, currentPage === value && styles.Pagination_item___current), "aria-label": "go to page " + value }, String(value).includes('Ellipsis') ? '...' : String(value)));
    };
    Pagination.prototype.render = function () {
        var _this = this;
        var _a = this.props, numberOfPages = _a.numberOfPages, currentPage = _a.currentPage, firstPageButtonText = _a.firstPageButtonText, lastPagePrefixButtonText = _a.lastPagePrefixButtonText, pagesDisplayedLimit = _a.pagesDisplayedLimit, className = _a.className;
        var lastPageText = lastPagePrefixButtonText + " " + numberOfPages;
        return (React__default.createElement("div", { className: clsx(styles.PaginationWrapper, className), "data-testid": this.props['data-testid'] },
            React__default.createElement("div", { className: styles.Pagination },
                React__default.createElement(Button, { variant: "tertiary", className: clsx(styles.Pagination_button, currentPage === 1 &&
                        styles.Pagination_button___disabled), onClick: function () { return _this.handleClick('first'); }, disabled: currentPage === 1 },
                    React__default.createElement(React__default.Fragment, null,
                        React__default.createElement("span", { className: styles.Pagination_navigation }, firstPageButtonText),
                        React__default.createElement(Icon, { name: "FirstPageIcon", alt: firstPageButtonText, className: clsx(styles.Pagination_navigation, styles.Pagination_navigation___mobile), size: 24 }))),
                React__default.createElement(ButtonBase, { type: "button", onClick: function () { return _this.handleClick('prev'); }, className: clsx(styles.Pagination_navIcon, currentPage === 1 &&
                        styles.Pagination_button___disabled), title: "ChevronLeftIcon", disabled: currentPage === 1, "aria-label": "previous page" },
                    React__default.createElement(IconChevronLeft, { size: 22 })),
                this.renderNumbers(currentPage, numberOfPages, pagesDisplayedLimit),
                React__default.createElement(ButtonBase, { type: "button", className: clsx(styles.Pagination_navIcon, currentPage === numberOfPages &&
                        styles.Pagination_button___disabled), onClick: function () { return _this.handleClick('next'); }, title: "IconChevronRight", disabled: currentPage === numberOfPages, "aria-label": "next page" },
                    React__default.createElement(IconChevronRight, { size: 22 })),
                React__default.createElement(Button, { variant: "tertiary", className: clsx(styles.Pagination_button, currentPage === numberOfPages &&
                        styles.Pagination_button___disabled), onClick: function () { return _this.handleClick('last'); }, disabled: currentPage === numberOfPages },
                    React__default.createElement(React__default.Fragment, null,
                        React__default.createElement("span", { className: styles.Pagination_navigation }, lastPageText),
                        React__default.createElement(Icon, { name: "LastPageIcon", alt: lastPageText, className: clsx(styles.Pagination_navigation, styles.Pagination_navigation___mobile), size: 24 }))))));
    };
    Pagination.displayName = 'Pagination';
    Pagination.propTypes = propTypes;
    Pagination.defaultProps = __assign({}, defaultProps);
    return Pagination;
}(React__default.Component));

export { Pagination as default };
